(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@youwol/math"));
	else if(typeof define === 'function' && define.amd)
		define("@youwol/course-01", ["@youwol/math"], factory);
	else if(typeof exports === 'object')
		exports["@youwol/course-01"] = factory(require("@youwol/math"));
	else
		root["@youwol/course-01"] = factory(root["@youwol/math"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__youwol_math__) {
return 